<template>
    <div>
        <v-list v-if="apiGroupEvents.length">
            <v-list-item v-for="event in apiGroupEvents" :key="event.id">
                <SoliBtn
                    block
                    @click="$emit('input', event)"
                    :text="event.title"
                    color="soli-grey"
                    outlined
                    class="mb-3"
                >
                </SoliBtn>
            </v-list-item>
        </v-list>
        <v-container v-if="!apiGroupEvents.length" class="mx-3">
            No events are available at this location
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        apiGroupEvents: {
            type: Array,
            default: [],
        },
    },
};
</script>
